import type { ItemsType } from "@/types/entities/legal";
import { TabItem } from "./TabItem";

interface TabListProps {
  items: ItemsType[];
  isDisabled?: boolean;
}

export const TabList = ({ items, isDisabled = false }: TabListProps) => {
  return (
    <div className="flex-1 border-b border-neutral">
      <ul className="flex flex-wrap -mb-px">
        {items.map((item) => (
          <TabItem
            key={item.label}
            item={item}
            isDisabled={isDisabled || item.isDisabled}
          />
        ))}
      </ul>
    </div>
  );
};
